import React from "react";
import PaieReferentielPage from "./PaieReferentielPage";

const RubriquesPaiePage = () => <PaieReferentielPage resource="rubriques" />;

export default RubriquesPaiePage;
